import React, { createContext, useContext } from 'react'

const PanelPatientContext = createContext<string | null>(null)

export const PanelPatientProvider = ({ uid, children }: { uid: string; children: React.ReactNode }) => (
  <PanelPatientContext.Provider value={uid}>{children}</PanelPatientContext.Provider>
)

export const usePanelPatientUid = (): string => {
  const uid = useContext(PanelPatientContext)

  if (!uid) {
    throw new Error('Advanced panels render only inside PanelPatientProvider')
  }

  return uid
}

// For components that also render outside a patient panel, such as tests of the feed.
export const useOptionalPanelPatientUid = (): string | null => useContext(PanelPatientContext)
